
import { useState } from 'react';
import { products } from '../../../mocks/products';

export default function Products() {
  const [selectedProduct, setSelectedProduct] = useState<typeof products[0] | null>(null);

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Collection
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover our range of handcrafted wooden bowls, each piece uniquely designed and crafted from locally sourced northeast Ohio wood
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer group"
              onClick={() => setSelectedProduct(product)}
            >
              <div className="relative w-full h-80 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                {product.featured && (
                  <div className="absolute top-4 right-4 bg-amber-700 text-white px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap">
                    Featured
                  </div>
                )}
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{product.name}</h3>
                <p className="text-sm text-gray-600 mb-4 line-clamp-2">{product.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-amber-700">${product.price}</span>
                  <button className="px-4 py-2 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition-colors whitespace-nowrap">
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Product Modal */}
        {selectedProduct && (
          <div
            className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedProduct(null)}
          >
            <div
              className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="relative">
                <button
                  onClick={() => setSelectedProduct(null)}
                  className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors z-10 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl text-gray-900"></i>
                </button>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-8">
                  <div className="w-full h-96 rounded-lg overflow-hidden">
                    <img
                      src={selectedProduct.image}
                      alt={selectedProduct.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <h3 className="text-3xl font-bold text-gray-900 mb-4">{selectedProduct.name}</h3>
                    <p className="text-lg text-gray-700 mb-6">{selectedProduct.description}</p>
                    <div className="mb-6">
                      <span className="text-3xl font-bold text-amber-700">${selectedProduct.price}</span>
                    </div>
                    <div className="space-y-4 mb-8">
                      <div className="flex items-start">
                        <i className="ri-checkbox-circle-line text-xl text-amber-700 mr-3 mt-1"></i>
                        <p className="text-sm text-gray-600">Handcrafted from locally sourced northeast Ohio wood</p>
                      </div>
                      <div className="flex items-start">
                        <i className="ri-checkbox-circle-line text-xl text-amber-700 mr-3 mt-1"></i>
                        <p className="text-sm text-gray-600">Each piece is unique with natural wood grain patterns</p>
                      </div>
                      <div className="flex items-start">
                        <i className="ri-checkbox-circle-line text-xl text-amber-700 mr-3 mt-1"></i>
                        <p className="text-sm text-gray-600">Food-safe finish suitable for serving and display</p>
                      </div>
                      <div className="flex items-start">
                        <i className="ri-checkbox-circle-line text-xl text-amber-700 mr-3 mt-1"></i>
                        <p className="text-sm text-gray-600">Sustainable and environmentally responsible sourcing</p>
                      </div>
                    </div>
                    <button className="w-full px-6 py-4 bg-amber-700 text-white text-base font-semibold rounded-lg hover:bg-amber-800 transition-colors whitespace-nowrap">
                      Inquire About This Piece
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
